// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorHeadline_root__1RF8J"};